import { presentUnexpectedFailure } from '../../shared/sentry/presentUnexpectedFailure';

const LOYALTY_CODES = new Set([
  'feature_disabled',
  'loyalty_feature_disabled',
  'operationId_required',
  'loyalty_program_invalid',
  'program_id_required',
  'loyalty_sale_payload_incomplete',
  'customer_not_found',
  'below_min_redeem',
  'insufficient_points',
  'loyalty_customer_required',
  'loyalty_no_active_program',
  'loyalty_discount_mismatch',
  'loyalty_void_insufficient_balance',
]);

/** Extrae código estable de Error.message / PostgREST. */
export function extractLoyaltyErrorCode(error: unknown): string | null {
  const raw =
    typeof error === 'string'
      ? error
      : error instanceof Error
        ? error.message
        : error && typeof error === 'object' && 'message' in error
          ? String((error as { message: unknown }).message)
          : '';
  if (!raw) return null;
  const trimmed = raw.trim();
  if (LOYALTY_CODES.has(trimmed)) return trimmed;
  for (const code of LOYALTY_CODES) {
    if (trimmed.includes(code)) return code;
  }
  const applyFailed = trimmed.match(/loyalty_apply_failed:\s*(\S+)/i);
  if (applyFailed?.[1]) return applyFailed[1];
  return null;
}

/** Mensaje accionable (vos) para códigos de fidelización. */
export function mapLoyaltyRemoteError(codeOrMessage: string | null | undefined): string {
  const code = extractLoyaltyErrorCode(codeOrMessage) ?? (codeOrMessage ?? '').trim();
  switch (code) {
    case 'feature_disabled':
    case 'loyalty_feature_disabled':
      return 'Fidelización no está habilitada en este momento.';
    case 'insufficient_points':
      return 'No alcanza el saldo de puntos para ese canje.';
    case 'below_min_redeem':
      return 'Ese canje está por debajo del mínimo del programa.';
    case 'loyalty_discount_mismatch':
      return 'El descuento de puntos no coincide con el programa. Revisá el canje.';
    case 'loyalty_customer_required':
      return 'Para canjear puntos tenés que elegir un cliente.';
    case 'loyalty_no_active_program':
      return 'No hay un programa de puntos activo. Configuralo en Fidelización.';
    case 'loyalty_program_invalid':
      return 'Revisá los números del programa (tienen que ser mayores a cero).';
    case 'customer_not_found':
      return 'No encontramos ese cliente para fidelización.';
    case 'operationId_required':
      return 'No pudimos guardar: faltó el id de operación. Reintentá.';
    case 'loyalty_void_insufficient_balance':
      return 'No se pudo revertir los puntos al anular (saldo insuficiente).';
    default:
      return 'No pudimos completar la operación de puntos. Reintentá.';
  }
}

export function presentLoyaltyFailure(args: {
  op: string;
  error: unknown;
  userMessage?: string;
}): void {
  const code = extractLoyaltyErrorCode(args.error);
  const mapped = mapLoyaltyRemoteError(code ?? (args.error instanceof Error ? args.error.message : null));
  presentUnexpectedFailure({
    module: 'loyalty',
    op: args.op,
    error: args.error,
    userMessage: args.userMessage ?? mapped,
  });
}
